import { inject, Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';

import { RequestsApiService } from './requests-api.service';
import { RequestEntitiesService } from './request-entities.service';
import { RequestComment } from '@core/types/RequestComment';
import {
  CreateRestrictedRequestCommentDto,
  RestrictedRequestCommentDto,
} from '@outkeep/shared';

@Injectable({
  providedIn: 'root',
})
export class RequestCommentsService extends RequestEntitiesService<
  RequestComment[]
> {
  private readonly requestsApiService = inject(RequestsApiService);

  readonly source$ = (requestId: number) =>
    this.requestsApiService
      .getRequestComments$(requestId)
      .pipe(
        map(comments =>
          comments
            .filter(({ text }) => text && !text.includes('<b>Описание сделки:'))
            .sort(
              (a, b) =>
                new Date(a.createdAt).getTime() -
                new Date(b.createdAt).getTime(),
            ),
        ),
      );

  createRequestComment$(requestId: number, text: string) {
    return this.requestsApiService.createRequestComment$(requestId, text);
  }

  deleteRequestComment$(commentId: number) {
    return this.requestsApiService.deleteRequestComment$(
      this.requestService.$request().id,
      commentId,
    );
  }

  deleteMultipleRequestComments$(commentIds: number[]) {
    return forkJoin(commentIds.map(id => this.deleteRequestComment$(id)));
  }

  createRestrictedRequestComment$(
    requestNumber: string,
    body: CreateRestrictedRequestCommentDto,
  ): Observable<RestrictedRequestCommentDto> {
    return this.requestsApiService.createRestrictedRequestComment$(
      requestNumber,
      body,
    );
  }

  createRestrictedRequestGuestComment$(
    token: string,
    body: CreateRestrictedRequestCommentDto,
  ): Observable<RestrictedRequestCommentDto> {
    return this.requestsApiService.createRestrictedRequestGuestComment$(
      token,
      body,
    );
  }
}
